// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"a1ddeee9","228":"95382d67","300":"68c46b7f","320":"90c79f79","368":"020339fc","592":"1706a54d","600":"c3baa924","780":"a29c69ec"}[chunkId] + ".chunk.js";
};